var map = {
	"./81ez83BNLcL._AC_SX679_.jpg": 3815,
	"./banana.png": 3448,
	"./default.png": 1836,
	"./grape.png": 7338,
	"./orange.png": 77,
	"./おこめ.jpg": 3581,
	"./ちゃおず.jpg": 7607,
	"./シャウエッセン.webp": 5099,
	"./スクリーンショット 2025-04-07 114631.png": 5265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;